import {Badge, Box, Table} from '@chakra-ui/react'
import {getYearMonthFormatter, getYearMonthFormatterUTC} from '@cypro/ui/utils'
import {MappedRestVials} from '@cypro/engine/utils'
import {AggregatedTableRow} from './aggregated-collapsible'
import {useTranslate} from '@tolgee/react'

export function AggregatedTable({
  tableRows,
  mappedRestVials,
  type,
}: {
  tableRows: AggregatedTableRow[]
  mappedRestVials?: MappedRestVials[]
  type: 'activeSubstances' | 'carrier' | 'solvents' | 'consumables'
}) {
  const {t} = useTranslate('common')
  return (
    <Box containerType="inline-size" width="100%">
      <Table.Root width={'100%'} size="sm">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>{t('qty')}</Table.ColumnHeader>
            <Table.ColumnHeader>{t('product')}</Table.ColumnHeader>
            <Table.ColumnHeader>{t('storage_location')}</Table.ColumnHeader>
            <Table.ColumnHeader css={{'@container (max-width: 600px)': {display: 'none'}}}>
              {t('expiration_date')}
            </Table.ColumnHeader>
            <Table.ColumnHeader css={{'@container (max-width: 600px)': {display: 'none'}}}>
              {t('order_id')}
            </Table.ColumnHeader>
            <Table.ColumnHeader></Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {mappedRestVials &&
            mappedRestVials.map(row => (
              <Table.Row key={row.batchId}>
                <Table.Cell>1</Table.Cell>
                <Table.Cell>{row.batchInfo?.tradeName?.name}</Table.Cell>
                <Table.Cell>{row.batchInfo?.stockLocation?.name}</Table.Cell>
                <Table.Cell css={{'@container (max-width: 600px)': {display: 'none'}}}>
                  {getYearMonthFormatter().format(new Date(row?.expiryDate))}
                </Table.Cell>
                <Table.Cell css={{'@container (max-width: 600px)': {display: 'none'}}}>
                  <Box display="flex" flexDirection="row" gap="1" flexWrap="wrap">
                    {row.ordersSharingThisBatch?.map(id => (
                      <Badge key={id}>{id}</Badge>
                    ))}
                  </Box>
                </Table.Cell>
                <Table.Cell>
                  <Box display="flex" flexDirection="row" gap="1" flexWrap="wrap">
                    <Badge colorPalette="orange" size="sm" flexShrink={0}>
                      {t('rest_vial')}
                    </Badge>
                  </Box>
                </Table.Cell>
              </Table.Row>
            ))}
          {tableRows.map(row => (
            <Table.Row key={row.batchId}>
              <Table.Cell>{row.quantity}</Table.Cell>
              <Table.Cell>
                {type === 'consumables' ? row.batchInfo?.consumable?.name : row.batchInfo?.tradeName?.name}
              </Table.Cell>
              <Table.Cell>{row.batchInfo?.stockLocation?.name}</Table.Cell>
              <Table.Cell css={{'@container (max-width: 600px)': {display: 'none'}}}>
                {getYearMonthFormatterUTC().format(new Date(row.batchInfo?.expiryDate))}
              </Table.Cell>
              <Table.Cell css={{'@container (max-width: 600px)': {display: 'none'}}}>
                <Box display="flex" flexDirection="row" gap="1" flexWrap="wrap">
                  {row.sharedWith.map(id => (
                    <Badge key={id}>{id}</Badge>
                  ))}
                  {row.ordersSharingThisBatch?.map(id => (
                    <Badge key={id}>{id}</Badge>
                  ))}
                </Box>
              </Table.Cell>
              <Table.Cell>
                {row.sharedWith.length > 0 && <Badge colorPalette="blue">{t('shared_vial')}</Badge>}
                {row?.ordersSharingThisBatch && row.ordersSharingThisBatch.length > 1 && (
                  <Badge colorPalette={'blue'}>
                    {t('shared_in_orders', {count: row?.ordersSharingThisBatch?.length})}
                  </Badge>
                )}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  )
}
